import { createAsyncThunk } from '@reduxjs/toolkit';

import axios  from 'config/axios';
import { 
  setThreatActors,
  setMitreMappings,
  setErrors,
  setDimensions,
  setSeverities,
  setAvailableDimensions } from 'stores/modules/rhymscan/datareducer';

export const fetchThreatActors = createAsyncThunk('rsData/fetchThreatActors', async ({  params }, { dispatch }) => {
  try {
    dispatch(setThreatActors([]));
    setErrors([]);
  
    const response = await axios.get(`${process.env.REACT_APP_RS_DASHBOARD_ENDPOINT_URL}/dashboard/apt-list`, {
      params: params,
    });
    if (response.status === 200){
      dispatch(setThreatActors(response.data.data));
    }
    else{
      dispatch(setErrors(response.data));
    }
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});

export const fetchOverAllScore = async ({  params }) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_RS_DASHBOARD_ENDPOINT_URL}/dashboard/overall-score`, {
      params: params,
    });
    if (response.status === 200){
      return response.data;
    }
    else{
      return response.data;
    }
  } catch (error) {
    return error
  }
};

export const fetchAlertAnalysis = async ({  params }) => {
  try {
    let response;
    if (params.compliance){
      delete params.compliance;
      response = await axios.get(`${process.env.REACT_APP_RS_DASHBOARD_ENDPOINT_URL}/dashboard/compliance/alerts-analysis`, {
        params: params,
      });
    }
    else{
      response = await axios.get(`${process.env.REACT_APP_RS_DASHBOARD_ENDPOINT_URL}/dashboard/alerts-analysis`, {
        params: params,
      });
    }
    if (response.status === 200){
      return response.data;
    }
    else{
      return response.data;
    }
  } catch (error) {
    return error
    // dispatch(setErrors(error.response));
  }
};

export const fetchAlertsTrend = async ({  params }) => {
  try {
    let response;
    if (params.compliance){
      delete params.compliance;
    }
    response = await axios.get(`${process.env.REACT_APP_RS_DASHBOARD_ENDPOINT_URL}/dashboard/alerts-trend`, {
      params: params,
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const fetchDomainsPerfomance = async ({  params }) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_RS_DASHBOARD_ENDPOINT_URL}/dashboard/domain-performance`, {
      params: params,
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const fetchDomainsHeatmapPerfomance = async ({  params }) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_RS_DASHBOARD_ENDPOINT_URL}/dashboard/getDomainPerformanceHeatmap`, {
      params: params,
    });
    return response;
  } catch (error) {
    return error;
  }
};

// eslint-disable-next-line no-empty-pattern
export const fetchRSDimensions = createAsyncThunk('rsData/fetchDimensions', async ({ },{ dispatch }) => {
  try {
    dispatch(setDimensions([]));
    setErrors([]);
    
    const response = await axios.get(`${process.env.REACT_APP_RS_DIMENSION_ENDPOINT_URL}/dimensions`, { 
    });
    if (response.status === 200){
      dispatch(setDimensions(response.data));
    }
    else{
      dispatch(setErrors(response.data));
    }
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});

// eslint-disable-next-line no-empty-pattern
export const fetchSeverities = createAsyncThunk('rsData/fetchSeverities', async ({ },{ dispatch }) => {
  try {
    dispatch(setSeverities([]));
    setErrors([]);
    const response = await axios.get(`${process.env.REACT_APP_RS_SEVERITY_ENDPOINT_URL}/severities`, {
    });
    const severities = response.data.sort((a, b) => {
      if (a.grade < b.grade) {
        return -1;
      }
      if (a.grade > b.grade) {
        return 1;
      }
      return 0;
    });

    dispatch(setSeverities(severities));
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});

export const fetchAvailableDimensions = createAsyncThunk('rsData/fetchAvailableDimensions', async ({ params }, { dispatch }) => {
  try {
    const updatedParams = { ...params };
    let response = await axios.get(`${process.env.REACT_APP_RS_DASHBOARD_ENDPOINT_URL}/dashboard/available-dimensions`, {
      params: updatedParams,
    });
    dispatch(setAvailableDimensions(response.data));
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});


export const saveNewDimension= async({body})=>{
  try{
    let response= await axios.post(`${process.env.REACT_APP_RS_DIMENSION_ENDPOINT_URL}/createDimension`,body,
    {
      'Content-Type': 'application/json',
    });
   return response;
  }catch(error){
    return error.response;
  }

}
export const saveNewSubDimensionByDimension= async({dimension,body})=>{
  try{
    let response= await axios.post(`${process.env.REACT_APP_RS_DIMENSION_ENDPOINT_URL}/createSubdimension?dimension=`+dimension,body,
    {
      'Content-Type': 'application/json',
    });
   return response;
  }catch(error){
    return error.response;
  }
}
export const updateDimensionById = async(dimensionId,{body})=>{
  try{
    let response = await axios.put(`${process.env.REACT_APP_RS_DIMENSION_ENDPOINT_URL}/dimension/`+dimensionId,body,
      {
        'Content-Type': 'application/json',
      }
    )
    return response;
  }catch(error){
    return error;   
  }
}

export const fetchRHYMSCANDimensions= async()=>{
  try{
    let response = await axios.get(`${process.env.REACT_APP_RS_DIMENSION_ENDPOINT_URL}/alldimensions`,{
    })
    return response;
  }catch(error){
    return error;   
  }
  
}

export const fetchRHYMSCANSubDimensionsByDimensionId = async({dimensionId})=>{
  try{
    let response = await axios.get(`${process.env.REACT_APP_RS_DIMENSION_ENDPOINT_URL}/subdimensionsBydimension/`+dimensionId,{
    })
    return response;
  }catch(error){
    return error;   
  }
  
}

export const updateDimensionweightages = async({body})=>{
  try{
    let response = await axios.put(`${process.env.REACT_APP_RS_DIMENSION_ENDPOINT_URL}/dimensions/update-weights`,body,
      {
        'Content-Type': 'application/json',
      }
    )
    return response;
  }catch(error){
    return error;   
  }
}

export const fetchMitreMappings = createAsyncThunk('rsData/fetchMitreMappings', async ({idToken, params }, { dispatch }) => {
  try {
    dispatch(setMitreMappings([]));
    setErrors([]);
    const response = await axios.get(`${process.env.REACT_APP_RS_DASHBOARD_ENDPOINT_URL}/dashboard/mitremapping`, {
      params: params,
    });
    if (response.status === 200){
      dispatch(setMitreMappings(response.data.data));
    }
    else{
      dispatch(setErrors(response.data));
    }
  } catch (error) {
    dispatch(setErrors(error.response));
  }
});